
<div mat-dialog-title>Export Portfolio Result Detail<button class="close" mat-button data-cancel-button title="Cancel" (click)="close()"><i class="material-icons clear">clear</i>
</button></div>
<mat-dialog-content>
  <mat-card class="block error" data-no-selection-error-message *ngIf="!isFormValid">
    <mat-card-title style="white-space: pre-line;">
      Please select at least one section to include in the export.
    </mat-card-title>
  </mat-card>

  <div class="dblock" data-detail-message *ngIf="isDetail">
    <div>Select which sections of the document you want to export to a PDF. The exported document will reflect your current view settings in the Portfolio Results Details.</div>
  </div>

  <div class="dblock" data-summary-message *ngIf="isSummary">
    <div class="block">The results for the portfolios you selected will be exported to a PDF. Each portfolio will be shown separately, and the PDF will contain the sections you select below.</div>
    <div>Please note: You are only able to export multiple results for portfolios in a pending state. If you want to export a PDF for a portfolio in a state other than pending, go to the result detail screen for that portfolio and export from there.</div>
  </div>

  <div class="dblock"><span class="bold">Exporting:</span>&nbsp;<span data-rebalance-name>{{this.data.rebalanceName}}_{{this.data.rebalanceId}}</span></div>

  <div class="dblock" *ngIf="isSummary" data-portfolios-selected>{{this.data.selectedPortfolios.length}}&nbsp;portfolio(s) selected</div>

  <div class="block bold">Customize exported document</div>
  <div class="irb-border-box">
    <div class="dblock" style="display: flex; flex-direction: row; gap: 10px;">
      <div class="bold" style="width: 130px">Summary</div>
      <mat-slide-toggle [checked]="config.showSummaryReport" (change)="config.showSummaryReport = !config.showSummaryReport;" [disabled]="false" data-summary-checkbox></mat-slide-toggle>
    </div>
    <div class="dblock" style="display: flex; flex-direction: row; gap: 10px;">
      <div class="bold" style="width: 130px">Cash Values</div>
      <mat-slide-toggle [checked]="config.showCashReport" (change)="config.showCashReport = !config.showCashReport;" [disabled]="false" data-cash-values-checkbox></mat-slide-toggle>
    </div>
    <div class="dblock" style="display: flex; flex-direction: row; gap: 10px;">
      <div class="bold" style="width: 130px">Orders</div>
      <mat-slide-toggle [checked]="config.showOrderReport" (change)="config.showOrderReport = !config.showOrderReport;" [disabled]="false" data-orders-checkbox></mat-slide-toggle>
    </div>
    <div class="dblock" style="display: flex; flex-direction: row; gap: 10px;">
      <div class="bold" style="width: 130px">Allocation Table</div>
      <mat-slide-toggle [checked]="config.showAllcnReport" (change)="config.showAllcnReport = !config.showAllcnReport;" [disabled]="false" data-allocations-checkbox></mat-slide-toggle>
    </div>
    <div style="display: flex; flex-direction: row; gap: 10px;">
      <div class="bold" style="width: 130px">Allocation Charts</div>
      <mat-slide-toggle [checked]="config.showAllcnChartReport" (change)="config.showAllcnChartReport = !config.showAllcnChartReport;" [disabled]="false" data-allocation-chart-checkbox></mat-slide-toggle>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <button class="btn-medium-secondary" data-close-button (click)="close()">Cancel</button>
  <button class="btn-medium-primary" data-continue-button [disabled]="!isFormValid" (click)="continue()">Export
  </button>
</mat-dialog-actions>
